import API from '../..';
const ENTITY = 'users';

export const changePasswordCompany = (id, data) =>
    API.put(`/api/v1/${ENTITY}/change-password-company/${id}/`, data);
export const changePasswordProfile = (data) =>
    API.post(`/api/v1/${ENTITY}/change-password-profile/`, data);
export const createUser = (data) => API.post(`/api/v1/${ENTITY}/`, data);
export const filterUsers = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/company/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
            status_flag: status,
        },
    });
export const getUsers = () => API.get(`/api/v1/${ENTITY}/`);
export const restartPassword = (id) =>
    API.put(`/api/v1/${ENTITY}/restart-password/${id}`);
export const updateConfigUser = (data) =>
    API.post(`/api/v1/settings/${ENTITY}/`, data);
export const updateUser = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
export const getUserPreset = (id) => API.get(`/api/v1/${ENTITY}/preset/${id}/`);
